import React from 'react';
import logo from './logo.svg';
import Router from "./pages/router";
// import "./assets/sdk/WebViewJavascriptBridge"; // 浏览器环境下暂时注释
import './App.css';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "./utils/useTranslation";
// @ts-ignore
import resources from 'locale-web/locales/aidoll/index';
import "./assets/sdk/mobileRequire";
import "./assets/sdk/WebViewJavascriptBridge";
import ReactDOM from "react-dom"; // 14.0版本后拆分成react和react-demo
import bridgeMsg from "reactPath/assets/sdk/bridgeMsg";
import titleBarTheme from "reactPath/constants/titleBarTheme";
import { localeMap } from "./constants/localeMap";
import * as Sentry from "@sentry/react";

// Transform resources to i18next format
const i18nResources = Object.keys(resources).reduce((acc: any, lang: string) => {
  acc[lang] = { translation: (resources as any)[lang] };
  return acc;
}, {} as any);

// 初始化i18n，先使用默认语言
i18n
  .use(initReactI18next)
  .init({
    resources: i18nResources,
    lng: "en", // 默认英文，等待协议获取实际语言
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });


function App() {
  const { i18n: i18nInstance, t } = useTranslation();
  
  React.useEffect(() => {
    // 先初始化 Sentry
    Sentry.init({
      dsn: process.env.SENTRY_INIT_URL,
      integrations: [
        Sentry.browserTracingIntegration(),
        // Sentry.replayIntegration(),
      ],
      beforeSendTransaction: (event) => {
        // 用户信息
        event.user = {
          username: '',
          pk: '',
        };
        return event;
      },
      // Tracing
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    // 通过协议获取页面参数
    bridgeMsg.message("getPageParams", ({ data }: { data: any }) => {
      const pageParams = data.data || data;

      const {username, productKey} = pageParams || {};
      
      // 更新 Sentry 用户信息
      Sentry.setUser({
        username: username || '',
        pk: productKey || '',
      });
      
      if (pageParams && pageParams.lang) {
        const { lang } = pageParams;
        // 使用语言映射表转换语言
        const localeLang = localeMap[lang] || lang?.split("_")?.[0] || "en";
        
        // 切换i18n语言
        i18n.changeLanguage(localeLang);
        
        // 保存语言到localStorage
        localStorage.setItem('app-lang', lang);
      }
    });
  }, []);

  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
